import { sammelnClient } from '@xver/libs/axios';

import { DeleteRepositoryResponse, ListRepositoriesResponse, RepositoryResponse } from './model';

const ENDPOINTS = {
    LIST: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}/repositories`,
    GET: (projectIdOrName: string, repoName: string) =>
        `/v1/projects/${projectIdOrName}/repositories/${repoName}`,
    DELETE: (projectIdOrName: string, repoName: string) =>
        `/v1/projects/${projectIdOrName}/repositories/${repoName}`,
};

export function listRepositories(projectIdOrName: string): Promise<ListRepositoriesResponse> {
    return sammelnClient.get(ENDPOINTS.LIST(projectIdOrName));
}

export function getRepository(
    projectIdOrName: string,
    repoName: string
): Promise<RepositoryResponse> {
    return sammelnClient.get(ENDPOINTS.GET(projectIdOrName, repoName));
}

export function deleteRepository(
    projectIdOrName: string,
    repoName: string
): Promise<DeleteRepositoryResponse> {
    return sammelnClient.delete(ENDPOINTS.DELETE(projectIdOrName, repoName));
}
